import React from 'react';
import { Mail } from 'lucide-react';

interface FooterProps {
    onNavigate: (view: any) => void;
}

// Custom X (Twitter) Logo Component
const XLogo = ({ size = 20 }: { size?: number }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="w-full bg-gray-50 border-t-2 border-gray-200 mt-auto">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-hand font-bold text-xl">LogiSketch</h3>
            <p className="font-hand text-sm text-gray-500">
              Turning abstract thoughts into visual metaphors since 2025.
            </p>
          </div>

          {/* Legal (Required for Stripe) */}
          <div className="space-y-4">
            <h4 className="font-sans font-bold text-sm uppercase tracking-wider text-gray-400">Legal</h4>
            <ul className="space-y-2 font-hand text-sm">
              <li>
                <button onClick={() => onNavigate('terms')} className="hover:underline decoration-yellow-400 decoration-2 underline-offset-2 text-left">Terms of Service</button>
              </li>
              <li>
                <button onClick={() => onNavigate('privacy')} className="hover:underline decoration-yellow-400 decoration-2 underline-offset-2 text-left">Privacy Policy</button>
              </li>
              <li>
                <button onClick={() => onNavigate('terms')} className="hover:underline decoration-yellow-400 decoration-2 underline-offset-2 text-left">Refund Policy</button>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div className="space-y-4">
            <h4 className="font-sans font-bold text-sm uppercase tracking-wider text-gray-400">Connect</h4>
            <div className="flex gap-4">
              <a href="https://x.com/NoCodeRyan" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-black transition-colors">
                <XLogo size={20} />
              </a>
              <a href="mailto:logisketchcom@gmail.com" className="text-gray-600 hover:text-black transition-colors">
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <p className="font-hand text-sm text-gray-400">
            &copy; {new Date().getFullYear()} LogiSketch. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;